export const VENCIDO = 'VENC'
export const VENCE_HOY = 'VEHO'
export const A_VENCER = 'AVEN'

export const __dictionary = {
  [VENCIDO]: {
    id: VENCIDO,
    nombre: 'VENCIDO'
  },
  [VENCE_HOY]: {
    id: VENCE_HOY,
    nombre: 'VENCE HOY'
  },
  [A_VENCER]: {
    id: A_VENCER,
    nombre: 'A VENCER'
  }
}

export const __array = [__dictionary[VENCIDO], __dictionary[VENCE_HOY], __dictionary[A_VENCER]]
